import apiInstance from './apiInstance';

// API methods
export const authAPI = {
  login: (credentials) => apiInstance.post('/auth/login', credentials),
  register: (userData) => apiInstance.post('/auth/register', userData),
  refresh: (refreshToken) => apiInstance.post('/auth/refresh', { refresh_token: refreshToken }),
  getCurrentUser: () => apiInstance.get('/auth/me'),
  updateProfile: (profileData) => apiInstance.put('/auth/profile', profileData),
  changePassword: (passwordData) => apiInstance.put('/auth/change-password', passwordData),
  logout: () => apiInstance.post('/auth/logout'),
};

export const vehicleAPI = {
  getMakes: () => apiInstance.get('/makes?with_product_count=true'),
  getModels: (makeId) => apiInstance.get(`/makes/${makeId}/models?with_product_count=true`),
  getSeries: (modelId) => apiInstance.get(`/models/${modelId}/series`),
  getBodyTypes: (seriesId) => apiInstance.get(`/series/${seriesId}/body-types`),
  getPositions: (bodyTypeId, year) => {
    const params = year ? `?year=${year}` : '';
    return apiInstance.get(`/body-types/${bodyTypeId}/positions${params}`);
  },
  getAllPositions: () => apiInstance.get('/positions'),
};

export const productsAPI = {
  getProducts: (filters) => {
    const params = new URLSearchParams();
    Object.entries(filters).forEach(([key, value]) => {
      if (value !== null && value !== undefined && value !== '') {
        params.append(key, value);
      }
    });
    return apiInstance.get(`/products?${params.toString()}`);
  },
  getProduct: (id) => apiInstance.get(`/products/${id}`),
  getRelatedProducts: (id) => apiInstance.get(`/products/${id}/related`),
  getProductPrice: (id) => apiInstance.get(`/products/${id}/price`),
  skuAutocomplete: (q) => apiInstance.get(`/products/sku-autocomplete?q=${encodeURIComponent(q)}`),
};

export const cartAPI = {
  getCart: () => apiInstance.get('/cart'),
  addToCart: (productId, quantity) => apiInstance.post('/cart', { product_id: productId, quantity }),
  updateCartItem: (productId, quantity) => apiInstance.put(`/cart/${productId}`, { quantity }),
  removeFromCart: (productId) => apiInstance.delete(`/cart/${productId}`),
  clearCart: () => apiInstance.delete('/cart'),
};

export const ordersAPI = {
  getOrders: (params) => {
    const searchParams = new URLSearchParams(params);
    return apiInstance.get(`/orders?${searchParams.toString()}`);
  },
  getOrder: (id) => apiInstance.get(`/orders/${id}`),
  createOrder: (orderData) => apiInstance.post('/orders', orderData),
};

export const customerAPI = {
  getProfile: () => apiInstance.get('/customers/profile'),
};

export const adminAPI = {
  getDashboard: () => apiInstance.get('/admin/dashboard'),
  getProducts: (params) => {
    const searchParams = new URLSearchParams(params);
    return apiInstance.get(`/admin/products?${searchParams.toString()}`);
  },
  getOrders: (params) => {
    const searchParams = new URLSearchParams(params);
    return apiInstance.get(`/admin/orders?${searchParams.toString()}`);
  },
  getCustomers: (params) => {
    const searchParams = new URLSearchParams(params);
    return apiInstance.get(`/admin/customers?${searchParams.toString()}`);
  },
  // Product Images
  getProductImages: (id) => apiInstance.get(`/admin/products/${id}/images`),
  uploadProductImages: (id, formData) =>
    apiInstance.post(`/admin/products/${id}/images`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    }),
  // Model Image
  uploadModelImage: (id, formData) =>
    apiInstance.post(`/admin/models/${id}/image`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    }),
};

export const customerPricingAPI = {
  getCustomerPricingCategories: (params) => {
    const searchParams = new URLSearchParams(params);
    return apiInstance.get(`/customer-pricing-categories?${searchParams.toString()}`);
  },
  getCustomers: (params) => {
    const searchParams = new URLSearchParams(params);
    return apiInstance.get(`/customers?${searchParams.toString()}`);
  },
  getProducts: (params) => {
    const searchParams = new URLSearchParams(params);
    return apiInstance.get(`/products?${searchParams.toString()}`);
  },
  createPricingCategory: (data) => apiInstance.post('/customer-pricing-categories', data),
  updatePricingCategory: (id, data) => apiInstance.put(`/customer-pricing-categories/${id}`, data),
  deletePricingCategory: (id) => apiInstance.delete(`/customer-pricing-categories/${id}`),
  bulkCreatePricing: (data) => apiInstance.post('/customer-pricing-categories/bulk-create', data),
  bulkCreateDefaultPricing: () => apiInstance.post('/customer-pricing-categories/bulk-create-default'),
  downloadTemplate: () => apiInstance.get('/customer-pricing-categories/csv-template', { responseType: 'blob' }),
  uploadCSV: (formData) => apiInstance.post('/customer-pricing-categories/csv-upload', formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  })
};

// Export the apiInstance as default
export default apiInstance;
